var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80952 11.875H14.3C14.04 12.4625 13.8419 13.0875 13.7305 13.75H6.80952C3.04571 13.75 0 10.675 0 6.875C0 3.075 3.04571 0 6.80952 0H19.8095C22.5457 0 24.7619 2.2375 24.7619 5C24.7619 6.1375 24.3781 7.175 23.7343 8.0125C23.0657 7.75 22.3476 7.5875 21.6048 7.5375C22.3848 6.975 22.9048 6.05 22.9048 5C22.9048 3.275 21.5181 1.875 19.8095 1.875H6.80952C4.07333 1.875 1.85714 4.1125 1.85714 6.875C1.85714 9.6375 4.07333 11.875 6.80952 11.875ZM9.28572 8.125C8.60476 8.125 8.04762 7.5625 8.04762 6.875C8.04762 6.1875 8.60476 5.625 9.28572 5.625H18.5714V3.75H9.28572C7.57714 3.75 6.19048 5.15 6.19048 6.875C6.19048 8.6 7.57714 10 9.28572 10H15.5257C16.2314 9.2 17.0981 8.5625 18.0886 8.125H9.28572ZM22.2857 13.75V10H19.8095V13.75H16.0952V16.25H19.8095V20H22.2857V16.25H26V13.75H22.2857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.c7d1c21c79b054296ec4efa7beef4531.svg";
export { ForwardRef as ReactComponent };